// Try to get the values from a runtime-injected global variables.

const serverName =
  (typeof window !== 'undefined' && window.REACT_APP_CONFIG && window.REACT_APP_CONFIG.REACT_APP_API_SERVER) ||
  process.env.REACT_APP_API_SERVER;

const environment =
  (typeof window !== 'undefined' && window.REACT_APP_CONFIG && window.REACT_APP_CONFIG.REACT_APP_ENVIRONMENT) ||
  process.env.REACT_APP_ENVIRONMENT;

export default serverName;
export { environment };
